import { render, staticRenderFns } from "./PatientAnalysis.vue?vue&type=template&id=dc0f2412&scoped=true"
import script from "./PatientAnalysis.vue?vue&type=script&lang=js"
export * from "./PatientAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PatientAnalysis.vue?vue&type=style&index=0&id=dc0f2412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0f2412",
  null
  
)

export default component.exports